"use client";

import Link from "next/link";
import type { ComponentType } from "react";
import { Home, MapPinIcon, Swords, Flame, UserIcon } from "./icons";

type TabId = "home" | "find" | "play" | "feed" | "me";

type Tab = {
  id: TabId;
  label: string;
  href: string;
  icon: ComponentType<{ size?: number; strokeWidth?: number }>;
  primary?: boolean;
};

const TABS: Tab[] = [
  { id: "home", label: "Itthon", href: "/home", icon: Home },
  { id: "find", label: "Pálya", href: "/find-game", icon: MapPinIcon },
  { id: "play", label: "Játék", href: "/start-game", icon: Swords, primary: true },
  { id: "feed", label: "Hírek", href: "/events", icon: Flame },
  { id: "me", label: "Profil", href: "/profile", icon: UserIcon },
];

type Props = { active?: TabId };

/**
 * BottomNav — mobile bottom tab-bar (5 tabs, center one acid-highlighted).
 * Glassmorphism background, fixed to viewport bottom.
 */
export function BottomNav({ active = "home" }: Props) {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 flex px-3 pt-2.5 pb-[18px]"
      style={{
        background: "rgba(10,10,10,0.85)",
        backdropFilter: "blur(14px)",
        borderTop: "1px solid var(--color-border)",
      }}
    >
      {TABS.map((t) => {
        const isActive = t.id === active;
        const Icon = t.icon;
        return (
          <Link
            key={t.id}
            href={t.href}
            className="flex-1 flex flex-col items-center gap-1 py-1 font-body"
            style={{
              color: isActive ? "var(--color-acid)" : "var(--color-text-dim)",
              fontSize: 10,
              fontWeight: 600,
              letterSpacing: "0.03em",
              textTransform: "uppercase",
            }}
          >
            {t.primary ? (
              <div
                className="flex items-center justify-center"
                style={{
                  width: 44,
                  height: 30,
                  borderRadius: 6,
                  marginTop: -10,
                  background: "var(--color-acid)",
                  color: "#0a0a0a",
                  boxShadow:
                    "0 6px 18px -6px var(--color-acid-glow), inset 0 0 0 1px var(--color-acid-dim)",
                }}
              >
                <Icon size={18} strokeWidth={2.2} />
              </div>
            ) : (
              <Icon size={20} strokeWidth={isActive ? 2.2 : 1.7} />
            )}
            <span>{t.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
